import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  customers: [],
  customerById: {},
  totalCount: 0,
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Customer fetch successfully",
        customers: action.payload.data,
        totalCount: action.payload.total_count,
      };
    case TYPE.GET_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching customer",
        customers: [],
        totalCount: 0,
      };

    case TYPE.GET_CUSTOMER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        customerById: action.payload,
      };
    case TYPE.GET_CUSTOMER_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        customerById: {},
      };
    case TYPE.ACTIVATE_DEACTIVATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
      };
    case TYPE.ACTIVATE_DEACTIVATE_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      };
    case TYPE.UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
      };
    case TYPE.UPDATE_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      };
    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default customerReducer;
